import React from 'react';

import { InteractionStatus } from '../../../types/InteractionStatus';

import { murmurhash } from '../../../lib/js/hash';
import { getRequestIdFromHeaders } from '../../../lib/HeaderUtils/RequestID';
import { StatusInfoForms } from '../../../_lib/components/StatusInfo';
import { InputType } from './InputTypes';
import { windowLogger } from '../../../_lib/Logger/windowLogger';

export default class Utils {
  /**
   * Returns a message for InteractionStatus in Form
   *
   * InteractionStatus param for unique status only. Success, Sending and Failure are implemented here
   *
   * @param text Text that will be shown, can be a string or node.
   * @param status indicates Message look.
   * @param {*} text
   * @param {InteractionStatus} status
   */
  static createStatusMessage(text, status = null) {
    return {
      id: (typeof text === 'string' && murmurhash(text)) || 'unknown',
      text,
      status,
    };
  }

  /**
   * Returns as single <InteractionStatus /> wrapped by a div
   * @param statusMessage
   * @param status @see createStatusMessage
   * @param requestId
   * @returns {*}
   */
  static getStatusMessageElement(statusMessage, status = InteractionStatus.NONE, requestId = null) {
    const messages = [].concat(statusMessage);

    if (messages.find(message => message && message.text && status !== InteractionStatus.NONE)) {
      return (
        <div className="form__messages">
          {messages.map(message => {
            if (message && !message.text) {
              return null;
            }
            return (
              <StatusInfoForms
                modifier="right"
                message={message.text}
                type={message.status || status}
                key={message.id + message.status}
                requestId={requestId}
              />
            );
          })}
        </div>
      );
    }
    return null;
  }

  /**
   * Returns a array of <input type="hidden"> regarding to a given object of parameter
   * @param parameter
   * @returns {any[]}
   */
  static renderHiddenFields(parameter) {
    return Object.keys(parameter)
      .filter(key => parameter[key].type === InputType.HIDDEN)
      .map(key => {
        return (
          // eslint-disable-next-line jsx-a11y/control-has-associated-label
          <input
            key={`${parameter[key].name}-${parameter[key].type}`}
            name={parameter[key].name}
            type={parameter[key].type}
            value={parameter[key].value}
          />
        );
      });
  }

  /**
   * This Method will render Messages.
   *
   * All ErrorMessages will receive a status Fail.
   * Any specific message created with createStatusMessage() will be prioritized.
   * Else will look for the current sending status
   */
  static renderStatusMessages(messages, status, response) {
    let requestId = null;

    if (status === InteractionStatus.FAIL) {
      requestId = getRequestIdFromHeaders(response?.headers);
    }

    if (response?.data?.errorType) {
      if (messages[response.data.errorType]) {
        return Utils.getStatusMessageElement(messages[response.data.errorType], InteractionStatus.FAIL, null);
      }
      windowLogger.warn(`No Error Message Mapping for ${response.data.errorType}`);
      return Utils.getStatusMessageElement({ text: response.data.errorType }, InteractionStatus.FAIL, requestId);
    }

    return Utils.getStatusMessageElement(messages[status], status, requestId);
  }
}
